import { getPermalinkEncodedFilterKeys } from '@/features/seo-listing/consts';
import type { FilterState } from '../../store';

export type ListingPaginationSearchInput = {
  pathname: string;
  sortBy: FilterState['sortBy'];
  searchQuery: string;
  selectedFandoms: string[];
  selectedTags: string[];
  selectedUniverses: string[];
  selectedStatuses: string[];
  selectedRatings: string[];
  selectedCharacters: string[];
  selectedPairingCharacters: string[];
};

const joinIds = (values: string[]): string | undefined =>
  values.length > 0 ? values.join(',') : undefined;

/** Builds query params for crawlable pagination links (path-encoded keys are omitted). */
export const buildListingPaginationSearchParams = (
  input: ListingPaginationSearchInput,
): Record<string, string | undefined> => {
  const encodedKeys = getPermalinkEncodedFilterKeys(input.pathname);

  return {
    sort: input.sortBy !== 'hotNew' ? input.sortBy : undefined,
    search: input.searchQuery || undefined,
    fandoms: encodedKeys.includes('fandoms') ? undefined : joinIds(input.selectedFandoms),
    tags: encodedKeys.includes('tags') ? undefined : joinIds(input.selectedTags),
    universes: joinIds(input.selectedUniverses),
    statuses: joinIds(input.selectedStatuses),
    ratings: joinIds(input.selectedRatings),
    characters: encodedKeys.includes('characters') ? undefined : joinIds(input.selectedCharacters),
    pairingCharacters: encodedKeys.includes('pairingCharacters')
      ? undefined
      : joinIds(input.selectedPairingCharacters),
  };
};
